<template>
  <section class="black-bg">
    <div class="containerWrapper">
      <div class="hosts">
        <h3>Meet the <span class="text-outline">Host</span></h3>
        <div class="hosts__list">
          <div></div>
          <div @click="clickHost()" class="hosts__list-pic">
            <div>
              <img
                src="../assets/speaker_photo_arrow.svg"
                alt="Arrow"
                class="hosts-arrow"
              />
              <div class="hosts-photo-crop-wrapper">
                <img
                  src="../assets/host-kritika.png"
                  alt="host of event"
                  class="hosts-photo-crop"
                />
              </div>
              <img
                src="../assets/host-kritika.png"
                alt="host of event"
                class="hosts-photo-crop"
              />
            </div>
            <h4 class="hosts-title">Kritika Rajbhandari</h4>
            <p class="hosts-position">
              <strong>Project Manager</strong>
            </p>
            <p class="hosts-workplace">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="#aeaeae"
              >
                <path
                  fill-rule="evenodd"
                  d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                  clip-rule="evenodd"
                /></svg
              >&nbsp;Leapfrog Technology
            </p>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { bus } from "../main";
export default {
  name: "Host",
  methods: {
    clickHost() {
      bus.$emit("openSideboxHost");
      document.body.classList.add("overflow-fix");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hosts {
  margin-bottom: 3rem;
  padding: 6rem 0rem;
}
.hosts h3 {
  color: var(--text-white);
  text-align: center;
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 1rem;
}
.hosts .text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}
.hosts__list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 60px;
}
.hosts__list .hosts__list-pic {
  margin: 2rem 0rem;
  cursor: pointer;
  position: relative;
  border: 0px;
  background-color: transparent;
}
.hosts__list .hosts__list-pic .hosts-arrow {
  width: 100%;
  display: none;
  position: absolute;
  transform: scale(1.2);
}
.hosts__list-pic:hover .hosts-arrow {
  display: block;
}
.hosts-photo-crop-wrapper {
  width: 100%;
  height: 50%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 0;
}
.hosts-photo-crop{
  border-radius: 2px;
}
.hosts__list h4 {
  font-size: 1.6rem;
  color: var(--primary-color);
  margin-top: 1rem;
}
.hosts__list .hosts-position {
  color: var(--lighter-grey);
  font-size: 1rem;
  margin-bottom: 1.2rem;
}
.hosts-workplace {
  display: flex;
  align-items: flex-start;
  color: var(--lighter-grey);
  font-size: 1rem;
}
@media (max-width: 992px) {
  .hosts__list {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .hosts__list .hosts__list-pic {
    margin: 0rem 0rem;
  }
  .hosts__list {
    display: flex;
    gap: 0px;
  }
  .hosts {
    padding: 0rem 0rem;
  }
  .hosts h3 {
    margin-bottom: 3rem;
  }
}
</style>
